import React, { ThHTMLAttributes } from 'react';

export interface VoxelDataTableHeadCellProps extends ThHTMLAttributes<HTMLTableCellElement> {
  padding?: any;
  className?: string;
  children?: any;
}

export const VoxelDataTableHeadCell = React.forwardRef<
  HTMLTableCellElement,
  VoxelDataTableHeadCellProps
>(({ className, ...tdProps }, ref) => {
  return (
    <td
      className={`
        py-1.5 px-3 text-[13px] font-medium text-gray-500
        border-y border-solid border-voxel-gray-200/80
        bg-voxel-gray-50
        ${className}
      `}
      ref={ref}
      {...tdProps}
    />
  );
});

export default VoxelDataTableHeadCell;
